module.exports = __webpack_public_path__ + "media/images/s01_08-44c1b9396b5bea99b634a29e79372096.svg";